<template>
  <div>
    <h2 class="title" v-if="State.packages.length === 0 && !error">
      <loader />
    </h2>

    <div class="notice_block block" v-if="State.netwerkstatus === 99" v-html="postcodeCheckNotDeliverableYetText">

    </div>

    <h2 class="title" v-if="State.packages.length !== 0">Kies het pakket dat bij jou past:</h2>

    <div class="presets-container" v-if="State.packages.length !== 0">
      <preset @select="select(preset)" v-for="preset in State.packages" :key="preset.id" :preset="preset" />
    </div>
    <h3 class="error" v-else-if="error" v-html="postcodeCheckErrorText">
     <!--      Helaas, op dit adres kun je nog geen diensten van {{companyName}} aanvragen. <br/>Denk je dat dit niet klopt? <br/>Controleer dan je-->
<!--      ingevoerde gegevens en doe de postcodecheck opnieuw of stuur een mail naar klantenservice@{{companyName}}.nl.-->
    </h3>
  </div>
</template>

<script>
import Loader from '../components/loader'
import Preset from '../components/preset'
import State from '../state'
import priceHelpers from '../helpers/priceHelpers'

export default {
  components: { Loader, Preset },
  data () {
    return {
      attempt: 0,
      State,
      error: false
    }
  },
  computed: {
    companyName: function () {
      return process.env.VUE_APP_COMPANY_NAME
    },
    postcodeCheckErrorText: function () {
      return process.env.VUE_APP_POSTCODE_CHECK_ERROR_TEXT
    },
    postcodeCheckNotDeliverableYetText: function () {
      return process.env.VUE_APP_POSTCODE_NOT_DELIVERABLE_YET_TEXT
    }
  },
  created () {
    this.load()
  },
  methods: {
    select (preset) {
      preset.categories = priceHelpers.addExtraPriceProperty(preset.categories)
      State.selection = preset
      this.$emit('select')
    },
    load () {
      let apiURL
      /* eslint-disable no-undef */
      if (typeof PlinqApiUrlData !== 'undefined') {
        apiURL = PlinqApiUrlData
        /* eslint-enable no-undef */
      } else {
        apiURL = process.env
      }
      // valid zipcode?
      var rege = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i
      if (!rege.test(State.zipcode)) {
        this.error = true
      } else {
        const requestData = new FormData()

        requestData.append('action', 'plinqapi')
        requestData.append('zipcode', State.zipcode.replaceAll(' ', '').replaceAll('+', '').toUpperCase())
        requestData.append('houseno', State.houseno)
        requestData.append('houseno_ext', State.houseno_ext !== null ? State.houseno_ext.replaceAll(' ', '').replaceAll('+', '').toUpperCase() : null)
        requestData.append('type', State.type)

        fetch(apiURL.VUE_APP_API_URL, {
          method: 'POST',
          body: requestData
        })
          .then(response => response.json()
          )
          .then(data => this.addInitialActiveState(data))
          .then(data => Object.assign(State, data))
          .then(data => {
            State.Zoekgegevens.city = data.city
            State.Zoekgegevens.street = data.street
            State.Zoekgegevens.houseno = data.houseno
            State.Zoekgegevens.houseno_ext = data.houseno_ext
            State.Zoekgegevens.zipcode = data.zipcode
            State.Zoekgegevens.room = data.room
            State.Zoekgegevens.network = data.network
            State.Zoekgegevens.cust_type = data.cust_type
            State.Zoekgegevens.netwerkstatus = data.netwerkstatus
            State.Zoekgegevens.netwerk_code = data.netwerk_code
            State.Zoekgegevens.netwerk_gebiedscode = data.netwerk_gebiedscode

            // if no packages, also give error
            console.log(State.packages)
            if (State.packages.length === 0) {
              this.error = true
            }
          }).then(data => {
          console.log(State.presets_on)
          console.log('trying to skip presets: using package Zelf samenstellen')
          if(State.presets_on === "N") {
            for(var i = 0; i < State.packages.length; i++) {
              if(State.packages[i].name === "Zelf samenstellen") {
                console.log('package zelf samenstellen found')
                this.select(State.packages[i])
              }
            }

          }
        })
          .catch(error => {
            if (this.attempt === 2) {
              this.error = true
            } else {
              this.attempt += 1
              this.load()
            }
            console.error('error: ', error)
          })

      }
    },
    addInitialActiveState (data) {
      data.packages.forEach(preset => {
        preset.categories.forEach(category => {
          category.products.forEach(product => {
            product.initialActive = product.active
            if(product.product_type == 3) {
              product.amount = product.amount ?? 0;
            }
          })
        })
      })

      return data
    }
  }
}
</script>

<style scoped lang="scss">
.presets-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.preset{
  max-width: 300px;
}

.notice_block{
  background-color: #FFFFFF;
  margin-bottom: 50px !important;
}

.error {
  text-align: center;
  vertical-align: middle;
}

@include mobile {
  .presets-container {
    overflow-x: scroll;
    overflow-y: visible;
    padding: 40px 0;
  }

  // .presets-container {
  //   flex-direction: column;

  //   & > div {
  //     margin-bottom: 60px;
  //   }
  // }
}
</style>
